import { render, staticRenderFns } from "./RightCabinet.vue?vue&type=template&id=6973ef2d"
import script from "./RightCabinet.vue?vue&type=script&lang=js"
export * from "./RightCabinet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports